export const generateDisplayFields = (fields) => {
  return fields.map((field) => {
    const isImage = field.type === "image";
    const isIcon = field.type === "icon";

    return {
      Header: field.label,
      accessor: field.label, // Display name for DataTable
      dataKey: field.name,   // Key from API data
      isImage,
      isIcon,
      ...(isImage && {
        width: field.width || 50,
        height: field.height || 50,
      }),
      ...(isIcon && {
        iconSize: field.iconSize || 18, // default icon size
      }),
    };
  });
};